import Vue from 'vue';
import './plugins/vuetify';
import firebase from 'firebase';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';
import store from './store';
import './components/firebaseInit';

Vue.config.productionTip = false;

let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});
